import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCurrentUser, clearAuth } from '../utils/auth';

const AdminHeader: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const user = getCurrentUser();

  const handleLogout = () => {
    clearAuth();
    window.location.href = '/login';
  };

  const isActivePage = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Admin Navigation */}
          <div className="flex items-center space-x-8">
            <div className="flex items-center">
              <span className="text-lg font-bold text-gray-900">Admin Panel</span>
            </div>
            
            <nav className="hidden md:flex space-x-6">
              <Link
                to="/admin/dashboard"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActivePage('/admin/dashboard')
                    ? 'bg-green-100 text-green-700'
                    : 'text-gray-700 hover:text-green-600 hover:bg-gray-100'
                }`}
              >
                Dashboard
              </Link>
              <Link
                to="/admin/contacts"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActivePage('/admin/contacts')
                    ? 'bg-green-100 text-green-700'
                    : 'text-gray-700 hover:text-green-600 hover:bg-gray-100'
                }`}
              >
                Contacts
              </Link>
              <Link
                to="/admin/volunteers"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActivePage('/admin/volunteers')
                    ? 'bg-green-100 text-green-700'
                    : 'text-gray-700 hover:text-green-600 hover:bg-gray-100'
                }`}
              >
                Volunteers
              </Link>
              <Link
                to="/admin/users"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActivePage('/admin/users')
                    ? 'bg-green-100 text-green-700'
                    : 'text-gray-700 hover:text-green-600 hover:bg-gray-100'
                }`}
              >
                Users
              </Link>
            </nav>
          </div>

          {/* User Menu */}
          <div className="flex items-center space-x-4">
            <Link
              to="/"
              className="text-sm text-gray-600 hover:text-green-600 transition-colors"
            >
              View Site
            </Link>
            
            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center space-x-2 text-sm font-medium text-gray-700 hover:text-green-600 transition-colors"
              >
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-semibold">
                    {user?.name?.charAt(0).toUpperCase() || 'A'}
                  </span>
                </div>
                <span className="hidden md:block">{user?.name || 'Admin'}</span>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 py-1">
                  <div className="px-4 py-2 text-sm text-gray-500 border-b border-gray-100">
                    <div className="font-medium">{user?.name}</div>
                    <div className="text-xs">{user?.email}</div>
                  </div>
                  
                  <Link
                    to="/admin/dashboard"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    onClick={() => setIsDropdownOpen(false)}
                  >
                    Dashboard
                  </Link>
                  
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                  >
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden border-t border-gray-200 py-2">
          <div className="flex space-x-4 overflow-x-auto">
            <Link
              to="/admin/dashboard"
              className={`px-3 py-1 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                isActivePage('/admin/dashboard')
                  ? 'bg-green-100 text-green-700'
                  : 'text-gray-700 hover:text-green-600'
              }`}
            >
              Dashboard
            </Link>
            <Link
              to="/admin/contacts"
              className={`px-3 py-1 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                isActivePage('/admin/contacts')
                  ? 'bg-green-100 text-green-700'
                  : 'text-gray-700 hover:text-green-600'
              }`}
            >
              Contacts
            </Link>
            <Link
              to="/admin/volunteers"
              className={`px-3 py-1 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                isActivePage('/admin/volunteers')
                  ? 'bg-green-100 text-green-700'
                  : 'text-gray-700 hover:text-green-600'
              }`}
            >
              Volunteers
            </Link>
            <Link
              to="/admin/users"
              className={`px-3 py-1 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                isActivePage('/admin/users')
                  ? 'bg-green-100 text-green-700'
                  : 'text-gray-700 hover:text-green-600'
              }`}
            >
              Users
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminHeader;
